/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import appsSkeletonLayouts from './appsSkeleton';
import bannerLayouts from './banner';
import bannerItemLayouts from './bannerItem';
import pdpLayouts from './pdp';
import appsCatalogLayouts from './appsCatalog';
import appSectionLayouts from './appSection';

const layouts = {
    skeleton: appsSkeletonLayouts,
    banner: bannerLayouts,
    bannerItem: bannerItemLayouts,
    pdp: pdpLayouts,
    appsCatalog: appsCatalogLayouts,
    appSection: appSectionLayouts,
};

export default layouts;
